import * as i0 from '@angular/core';
import { signal, computed, Directive, HostListener, Component, ChangeDetectionStrategy, ViewEncapsulation, ContentChild, inject, ElementRef, booleanAttribute, Input, Pipe, NgModule } from '@angular/core';
import { NgIf } from '@angular/common';
const _c0 = [[["", "brnAvatarImage", ""]], [["", "brnAvatarFallback", ""]]];
const _c1 = ["[brnAvatarImage]", "[brnAvatarFallback]"];
function BrnAvatarComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵprojection(1);
    i0.ɵɵelementContainerEnd();
  }
}
function BrnAvatarComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
let BrnAvatarImageDirective = /*#__PURE__*/(() => {
  class BrnAvatarImageDirective {
    constructor() {
      this.error = signal(false);
      this.loaded = signal(false);
      this.canShow = computed(() => {
        return this.loaded() && !this.error();
      });
    }
    onError() {
      this.error.set(true);
    }
    onLoad() {
      this.loaded.set(true);
    }
    static {
      this.ɵfac = function BrnAvatarImageDirective_Factory(t) {
        return new (t || BrnAvatarImageDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BrnAvatarImageDirective,
        selectors: [["img", "brnAvatarImage", ""]],
        hostBindings: function BrnAvatarImageDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("error", function BrnAvatarImageDirective_error_HostBindingHandler() {
              return ctx.onError();
            })("load", function BrnAvatarImageDirective_load_HostBindingHandler() {
              return ctx.onLoad();
            });
          }
        },
        exportAs: ["avatarImage"],
        standalone: true
      });
    }
  }
  return BrnAvatarImageDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BrnAvatarComponent = /*#__PURE__*/(() => {
  class BrnAvatarComponent {
    constructor() {
      this.image = null;
    }
    static {
      this.ɵfac = function BrnAvatarComponent_Factory(t) {
        return new (t || BrnAvatarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BrnAvatarComponent,
        selectors: [["brn-avatar"]],
        contentQueries: function BrnAvatarComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, BrnAvatarImageDirective, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.image = _t.first);
          }
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 2,
        consts: [["fallback", ""], [4, "ngIf", "ngIfElse"]],
        template: function BrnAvatarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵtemplate(0, BrnAvatarComponent_ng_container_0_Template, 2, 0, "ng-container", 1)(1, BrnAvatarComponent_ng_template_1_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const fallback_r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.image == null ? null : ctx.image.canShow())("ngIfElse", fallback_r1);
          }
        },
        dependencies: [NgIf],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return BrnAvatarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BrnAvatarFallbackDirective = /*#__PURE__*/(() => {
  class BrnAvatarFallbackDirective {
    constructor() {
      this.element = inject(ElementRef).nativeElement;
      this.userCls = signal('');
      this.useAutoColor = signal(false);
      this.textContent = inject(ElementRef).nativeElement.textContent;
    }
    getTextContent() {
      return this.element.textContent;
    }
    set class(cls) {
      this.userCls.set(cls);
    }
    set autoColor(value) {
      this.useAutoColor.set(value);
    }
    static {
      this.ɵfac = function BrnAvatarFallbackDirective_Factory(t) {
        return new (t || BrnAvatarFallbackDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BrnAvatarFallbackDirective,
        selectors: [["", "brnAvatarFallback", ""]],
        inputs: {
          class: "class",
          autoColor: [2, "autoColor", "autoColor", booleanAttribute]
        },
        exportAs: ["avatarFallback"],
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature]
      });
    }
  }
  return BrnAvatarFallbackDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function hashString(str) {
  let h;
  for (let i = 0; i < str.length; i++) h = Math.imul(31, h || 0) + str.charCodeAt(i) | 0;
  return h || 0;
}
function hashManyTimes(times, str) {
  let h = hashString(str);
  for (let i = 0; i < times; i++) h = hashString(String(h));
  return h;
}
function hexColorFor(str) {
  const hash = str.length <= 2 ? hashManyTimes(5, str) : hashString(str);
  let color = '#';
  for (let i = 0; i < 3; i += 1) {
    const value = hash >> i * 8 & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
}
const toInitial = (capitalize = true) => word => {
  const initial = word.charAt(0);
  return capitalize ? initial.toLocaleUpperCase() : initial;
};
const firstAndLast = initials => `${initials[0]}${initials[initials.length - 1]}`;
let InitialsPipe = /*#__PURE__*/(() => {
  class InitialsPipe {
    transform(name, capitalize = true, firstAndLastOnly = true, delimiter = ' ') {
      if (!name) return '';
      const initials = name.trim().split(delimiter).filter(Boolean).map(toInitial(capitalize));
      if (firstAndLastOnly && initials.length > 1) return firstAndLast(initials);
      return initials.join('');
    }
    static {
      this.ɵfac = function InitialsPipe_Factory(t) {
        return new (t || InitialsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "initials",
        type: InitialsPipe,
        pure: true,
        standalone: true
      });
    }
  }
  return InitialsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const isShortHand = hex => hex.length === 3;
const cleanup = hex => {
  const noHash = hex.replace('#', '').trim().toLowerCase();
  if (!isShortHand(noHash)) return noHash;
  return noHash.split('').map(char => char + char).join('');
};
const isBright = hex => Number.parseInt(cleanup(hex), 16) > 0xffffff / 1.25;
const BrnAvatarImports = [BrnAvatarComponent, BrnAvatarFallbackDirective, BrnAvatarImageDirective];
let BrnAvatarModule = /*#__PURE__*/(() => {
  class BrnAvatarModule {
    static {
      this.ɵfac = function BrnAvatarModule_Factory(t) {
        return new (t || BrnAvatarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BrnAvatarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return BrnAvatarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BrnAvatarComponent, BrnAvatarFallbackDirective, BrnAvatarImageDirective, BrnAvatarImports, BrnAvatarModule, InitialsPipe, hexColorFor, isBright };
